import { Protocol } from './_types';

export const LIB_PROTOCOL_KIWI_HARVEST_SCREEN_EVAL: Protocol = {
    id: "kiwi_harvest_screen_eval",
    title: "Advanced Kiwi Harvest Evaluation",
    description: "Harvest evaluation is performed to characterise new cultivars and selections on the base of their fruit traits. Visual and sensory fruit evaluation are applied to describe fruit quality and keeping ability after storage over a specified storage period. Characteristics such as colour and pattern, shapes and symmetry, defects and disorders and eating quality are evaluated in detail.",
    sampleType: "harvest",

    chars: [
        //* RIPENING CHARS
        "frut_ripe_stage", //? THIS WAS A BI-POLAR SCALE
        "frut_ripe_consist",
        "frut_firmness", //? THIS WAS A BI-POLAR SCALE
        "frut_mature_rate", //? THIS WAS A BI-POLAR SCALE

        //* VISUAL CHARS
        "kiwi_frut_pubescence",

        //* COLOUR AND PATTERN
        "kiwi_skin_colour_pick",
        "kiwi_skin_colour",
        "kiwi_flesh_colour_pick",
        "kiwi_flesh_colour",

        //* ADHESION
        "frut_skin_adhesion",

        //* SIZE
        "frut_size_consistency",

        //* SHAPE AND SYMMETRY
        "kiwi_shape_type",
        "frut_shape_consistent",

        //* TASTE
        "frut_taste_sugar", // TODO SHOULD WE RENAME THE LABEL OR DESCRIPTORS
        "frut_taste_acid", //? THIS WAS A BI-POLAR SCALE
        "frut_taste_balance", //? THIS WAS A BI-POLAR SCALE
        "frut_off_taste",

        //* AROMA
        "frut_taste_aroma",

        //* MOUTHFEEL
        "frut_taste_juice",

        //* POSTHARVEST PESTS
        "kiwi_postharv_pest_ident",
        "frut_postharv_insect_prev",
        "frut_postharv_insect_sever",

        //* POSTHARVEST DISEASES
        "frut_postharv_disease_broad",
        "frut_postharv_disease_prev",
        "frut_postharv_disease_sever",

        //* POSTHARVEST DAMAGE, DISORDERS AND DEFECTS
        "kiwi_postharv_defect_ident",
        "frut_all_defect_dmg_prev",
        "frut_all_defect_dmg_sever",

        //* HARVEST OVERALL
        "frut_overall_appear",
        "frut_overall_taste",
        "frut_overall_flavour",
        "frut_overall_texture",
        "frut_overall_color",

    ],

    measures: [
        "frut_length",
        "frut_weight",
        "frut_weight_fresh",
        "frut_weight_dry",
        "frut_diameter",
        "frut_firmness",
        "frut_tss",
        "frut_acid",
        "frut_starch",
        "frut_hue_angle",
        "frut_seeds_blackened",
    ],

    calculations: [
        "fruit_aspect_ratio",
        "sugar_acid_ratio_calc",

        //* CLASSIFICATIONS
        "frut_weight_classification_sa",
    ],

    indexes: [
        // TODO INDICES Cristoso Quality Index, OVERALL SCORING INDEX, MARKETABILITY INDEX
    ],

    // TODO KIWI STORAGE REGIMES?
}